export enum CMSColumnBlockSection {
  OneColumnBlockSection = 'OneColumnBlockSection',
  TwoColumnBlockSection = 'TwoColumnBlockSection',
}
